export const clusterTable = {
    title: 'Cluster List',
    userInputLabel: 'Filter clusters',
    userInputPlaceholder: 'Please enter a keyword',
    userInputExample: 'Example input: ammonia, chemical fibers, etc.',
    searchTarget: 'Search target',
    clusterName: 'Cluster Name',
    ipcLabel: 'Technology classification (IPC) label',
    inventionTitle: 'Title',
    publicationNumber: 'Publication Number',
    searchOption: 'Filter options',
    ipcCodeLabel: 'Technology classification (IPC) code',
    ipcCodePlaceholder: 'Please enter a keyword',
    searchButton: 'Filter',
    checkBoxLabel: 'Include all IPC labels within the cluster',
    countText: 'Number of clusters matching the search conditions: ',
    countNumber: '', // English doesn't use classifiers, so they're omitted.
    singleSort: '*You can sort a single column by clicking its header.',
    column1: 'Cluster ID',
    column2: 'Cluster Name',
    column3: 'Domain',
    column4: 'Score',
    column5: 'Score Growth Rate',
    column6: 'Market Expectation [m JPY]',
    column7: 'Growth Rate of Market Expectation',
    column8: 'Startup Market Expectation [m JPY]',
    column9: 'Growth Rate of Startup Market Expectation',

    csvColumn1: 'Cluster ID',
    csvColumn2: 'Cluster Name',
    csvColumn3: 'Domain',
    csvColumn4: 'Score',
    csvColumn5: 'Score Growth Rate',
    csvColumn6: 'Market Expectation [m JPY]',
    csvColumn7: 'Growth Rate of Market Expectation',
    csvColumn8: 'Startup Market Expectation [m JPY]',
    csvColumn9: 'Growth Rate of Startup Market Expectation',
    csvColumn10: 'Business Scale',
    csvColumn11: 'Number of Patent Applications',
    csvColumn12: 'Number of Forward Citations'
}
